export const blobUrl = 'https://secrzaapg5nnoosz.public.blob.vercel-storage.com/powerbet';
